import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
//import store from './stores';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import BootstrapVue3 from 'bootstrap-vue-3'
// Importa los estilos CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

import { BModal, BButton } from 'bootstrap-vue-3'

//import 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/app.css'
import axios from 'axios';

// Configurar axios
axios.defaults.baseURL = '/api';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

// Interceptor para agregar token a las peticiones
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Interceptor para manejar errores de respuesta
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Token expirado o inválido, redirigir a login
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            router.push('/login');
        }
        return Promise.reject(error);
    }
);

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
//app.use(store);
app.use(VueSweetalert2);
app.use(BootstrapVue3)
app.component('BModal', BModal)
app.component('BButton', BButton)
app.mount('#app');